import classNames from "classnames";
import { FC } from "react";
import { FormPlaceholderProps } from "./form-placeholder.types";

export const FormPlaceHolder: FC<FormPlaceholderProps> = ({ focused, error, label, required }) => {
  return (
    <div
      className={classNames("flex flex-row absolute duration-200 ease-in z-1", {
        "left-[20px] top-[19px]": !focused,
        "left-[20px] top-[10px]": focused,
      })}
    >
      <span
        className={classNames("font-[800] duration-200 ease-in uppercase", {
          "text-[18px]": !focused,
          "text-[10px] tracking-normal": focused,
          "text-error": error,
          "text-white": !error,
        })}
      >
        {label}
      </span>
      {required && (
        <span
          className={classNames("font-[700] duration-200 ease-in text-text-04 tracking-normal", {
            "text-[18px]": !focused,
            "text-[10px]": focused,
          })}
        >
          *
        </span>
      )}
    </div>
  );
};
